<template>
    <div class="query">
        <van-field label="所属市州:" :value="city" placeholder="请选择" readonly is-link @click="openSelectCity"/>
        <van-field label="所属区县:" :value="town" placeholder="请选择" readonly is-link @click="openSelectTown"/>
        <van-cell-group>
            <!--<verification-code-input @setVerificationCode="getVerificationCode"
                                     ref="childFunction"></verification-code-input>-->
            <Vue2Verify ref="verify" v-if="show" @closeClick="show = false" @success='success'
                        :imgSize="{width:'310px',height:'155px'}"></Vue2Verify>
        </van-cell-group>
        <div class="btn-submit-div">
            <van-button type="info" size="large" @click="submit">查询</van-button>
        </div>
        <van-popup v-model="cityShow" position="bottom">
            <van-picker :columns="cityNameList" show-toolbar @cancel="onCancelCity" @confirm="onConfirmCity"/>
        </van-popup>
        <van-popup v-model="townShow" position="bottom">
            <van-picker :columns="townNameList" show-toolbar @cancel="onCancelTown" @confirm="onConfirmTown"/>
        </van-popup>
        <van-list v-if="listShow" class="list" v-model="loading" :finished="finished" finished-text="没有更多了"
                  :error.sync="error"
                  error-text="请求失败，点击重新加载"
                  @load="loadMore">
            <div></div>
            <div class="boxList" v-for="(item,index) in list" :key="index" style="border-bottom: 2px solid #868686;">
                <van-divider :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0 16px' }">{{item.name}}</van-divider>
                <div class="boxList-item-1">
                    <span>制作单位编码:</span>
                    <span>{{item.code}}</span>
                </div>
<!--                <div class="boxList-item">-->
<!--                    <span>制作单位名称:</span>-->
<!--                    <span>{{item.name}}</span>-->
<!--                </div>-->
                <div class="boxList-item">
                    <span>门店电话:</span>
                    <span>{{item.phone}}</span>
                </div>
                <div class="boxList-item">
                    <span>制作地址:</span>
                    <span>{{item.address}}</span>
                </div>
            </div>
        </van-list>

    </div>
</template>

<script>
    import {CellGroup, Field, Popup, Picker, Toast, Button, List,Divider} from 'vant'
    import VerificationCodeInput from "@/components/verification-code-input/VerificationCodeInput";
    import {baseApiMap} from '@/api/base'
    import {queryApiMap} from "../../api/query";
    import Vue2Verify from "@/views/signUp/verify/verify"

    export default {
        name: "SealQuery",
        components: {
            Vue2Verify,
            VerificationCodeInput,
            [CellGroup.name]: CellGroup,
            [Field.name]: Field,
            [Popup.name]: Popup,
            [Picker.name]: Picker,
            [Toast.name]: Toast,
            [Button.name]: Button,
            [List.name]: List,
            [Divider .name]: Divider
        },
        data() {
            return {
                show: false,
                receiveVerificationCode: {}, // 接收验证码子组件传来verificationInfo对象
                city: '', // 选择的地市
                cityGuid: 'all', // 地市的guid
                cityShow: false,
                cityNameList: [], // 存放地市name列表
                cityList: [], // 存放地市信息
                town: '', // 选择区县
                townGuid: '', // 区县的guid
                townShow: false, // 区县选择器显示与隐藏
                townNameList: [], // 存放区县name列表
                townList: [], // 存放区县信息
                listShow: false, // 显示结果信息
                ps: 1000000,
                list: [],
                loading: false, // 是否显示加载loading图标
                finished: false, // 控制"没有更多了"的显示与隐藏
                error: false, // 控制访问接口异常情况下，可以再次重新访问接口
            }
        },
        mounted() {
            this.getCity()
            this.logger.visit('111','0')
        },
        methods: {
            /**
             * 获取地市
             */
            async getCity() {
                try {
                    const res = await this.$httpUtils.getCommonUtils(`${baseApiMap.region}/${global.cityCode}`)
                    if (res.data.succ) {
                        for (let index in res.data.data) {
                            let data = {
                                key: res.data.data[index].guid,
                                value: res.data.data[index].regionname
                            }
                            this.cityList.push(data)
                            this.cityNameList.push(res.data.data[index].regionname)
                        }
                    }
                } catch (error) {
                    console.log(error)
                }
            },

            /**
             * 打开地市选择器
             */
            openSelectCity() {
                this.cityShow = true
            },

            /**
             * 关闭地市选择器
             */
            onCancelCity() {
                this.cityShow = false
            },

            /**
             * 接收验证码输入框组件传来的verificationInfo对象
             * @param value 验证码输入框verificationInfo对象
             */
            getVerificationCode(value) {
                this.receiveVerificationCode = value
            },

            /**
             * 选择地市
             * @param value 选中的地市
             */
            async onConfirmCity(value, index) {
                this.city = value
                this.cityGuid = this.cityList[index].key
                this.cityShow = false
                this.town = ''
                this.townGuid = ''
                this.townNameList = []
                this.townList = []
                try {
                    const res = await this.$httpUtils.getCommonUtils(`${baseApiMap.region}/${this.cityGuid}`)
                    if (res.data.succ) {
                        for (let index in res.data.data) {
                            let data = {
                                key: res.data.data[index].guid,
                                value: res.data.data[index].regionname
                            }
                            this.townList.push(data)
                            this.townNameList.push(res.data.data[index].regionname)
                        }
                    }
                    this.logger.visit('111','1')
                } catch (error) {
                    console.log(error)
                }
            },

            /**
             * 打开区县选择器
             */
            openSelectTown() {
                this.townShow = true
            },

            /**
             * 关闭区县选择器
             */
            onCancelTown() {
                this.townShow = false
            },

            /**
             * 选择区县
             * @param value 选中的地市
             */
            onConfirmTown(value, index) {
                this.town = value
                this.townGuid = this.townList[index].key
                this.townShow = false
            },

          submit() {
            if(!this.townGuid) {
              Toast('请选择所属区县')
            } else {
              this.show=true
            }
          },

          async success(val) {
            try {
              this.ps = 1000000
              this.list = []
              const data = {
                ps: this.ps,
                pi: 1,
                q_region_s_lk: this.townGuid,
                genGuid: val.captchaVerification,
                validCode: val.captchaVerification
              };

              Toast.loading({
                duration: 0,       // 持续展示 toast
                forbidClick: true, // 禁用背景点击
                loadingType: 'spinner',
                message: '查询中...'
              })
              const res = await this.$httpUtils.getCommonUtils(queryApiMap.sealDirectory, data)
              this.show = false
              Toast.clear()
              if (res.data.succ && res.data.data.list.length > 0) {
                this.listShow = true
                this.list = res.data.data.list
                this.loading = false
                if (this.ps >= res.data.data.totalRow) {

                  this.finished = true
                } else {
                  this.finished = false
                }

              } else {
                this.finished = true
                this.loading = false
                Toast.fail('未查询到结果')
              }
            } catch (error) {
              this.error = true
              this.finished = true
              this.loading = false
              Toast.fail('服务器运行失败，请稍后再试。')
              console.log(error)
            }
          },

            /**
             * 点击查询
             */
            async query(v) {
                if(!this.townGuid) {
                    Toast('请选择所属区县')
                } else if (!this.receiveVerificationCode.verificationIsNoneStatus) {
                    Toast('请输入验证码')
                } else if (!this.receiveVerificationCode.verificationSuccessStatus) {
                    Toast('请输入正确的验证码')
                } else {
                    this.queryData(v)
                }
            },

            /**
             * 获取公章数据 一次性将所有的数据查询出来，因为接口要传递验证码，加载查询会有问题。
             * @param v 条数
             * @returns {Promise<void>}
             */
            async queryData(v) {
                try {
                    this.ps = v
                    this.list = []
                    const data = {
                        ps: this.ps,
                        pi: 1,
                        q_region_s_lk: this.townGuid,
                        genGuid: this.receiveVerificationCode.verificationCodeGuid,
                        validCode: this.receiveVerificationCode.verificationCode
                    };

                    Toast.loading({
                        duration: 0,       // 持续展示 toast
                        forbidClick: true, // 禁用背景点击
                        loadingType: 'spinner',
                        message: '查询中...'
                    })
                    const res = await this.$httpUtils.getCommonUtils(queryApiMap.sealDirectory, data)
                    Toast.clear()
                    //刷新图形验证码
                    this.$refs.childFunction.interactionVerificationCode()
                    if (res.data.succ && res.data.data.list.length > 0) {
                        this.listShow = true
                        this.list = res.data.data.list
                        this.loading = false
                        if (this.ps >= res.data.data.totalRow) {

                            this.finished = true
                        } else {
                            this.finished = false
                        }

                    } else {
                        this.finished = true
                        this.loading = false
                        Toast.fail('未查询到结果')
                    }
                } catch (error) {
                    this.error = true
                    this.finished = true
                    this.loading = false
                    Toast.fail('服务器运行失败，请稍后再试。')
                    console.log(error)
                }
            },

            // 加载更多
            async loadMore() {
                this.ps += 5
                this.queryData(this.ps)
            },
            back() {
                this.$router.go(-1);
            }
        }
    }
</script>

<style scoped>
    .van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after {
        border-width: 0;
    }
    .boxList-item-1{
        margin: 0 auto;
        width: 90%;
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #ccc;
    }

</style>
<style>
    @import "~@assets/css/public/Common.css";
</style>
